"use client";

const title = 'Videos | CRENESSITY® (crinecerfont) HCP';
const description = 'Watch videos about CRENESSITY® and how it may help treat classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.';
const url = 'https://www.crenessityhcp.com/videos';

export const homepageMeta = {
  title,
  footer: {
    code: <>CP-CFT-US-0263v5</>,
    codeDate: <>08/2026</>,
    codeYear: <>2026</>,
  },
  metadata: [
    {
      name: 'description',
      content: description,
    }, {
      name: 'twitter:title',
      content: title,
    }, {
      name: 'twitter:description',
      content: description,
    }, {
      property: 'og:title',
      content: title,
    }, {
      property: 'og:description',
      content: description,
    }, {
      property: 'og:url',
      content: url,
    }, {
      property: 'og:site_name',
      content: 'CRENESSITY® (crinecerfont) HCP Website'
    }, {
      property: 'og:type',
      content: 'website',
    }, {
      property: 'og:image',
      content: 'https://www.crenessityhcp.com/images/og/MOA_Hero-Image.png',
    }, 
  ],
  link: [
    {
      rel: 'canonical',
      href: url,
    }, {
      rel: 'alternate',
      hrefLang: 'en-us',
      href: url,
    },
  ],
  schemaTag: [
    {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "MedicalWebPage",
          "@id": "https://www.crenessityhcp.com/videos#webpage",
          "url": "https://www.crenessityhcp.com/videos",
          "name": "Videos | CRENESSITY® (crinecerfont) HCP",
          "description": "Watch educational videos about CRENESSITY® (crinecerfont) and the management of classic congenital adrenal hyperplasia (CAH). See full Prescribing and Safety Information.",
          "isPartOf": {
            "@type": "WebSite",
            "name": "CRENESSITY HCP",
            "url": "https://www.crenessityhcp.com"
          },
          "dateModified": "2025-11-10T00:00:00Z",
          "audience": {
            "@type": "MedicalAudience",
            "audienceType": "HealthcareProvider"
          },
          "about": [
            {
              "@type": "MedicalCondition",
              "name": "Classic congenital adrenal hyperplasia (CAH)",
              "sameAs": "https://medlineplus.gov/genetics/condition/congenital-adrenal-hyperplasia/"
            },
            {
              "@type": "Drug",
              "name": "crinecerfont",
              "alternateName": [
                "CRENESSITY",
                "CRENESSITY crinecerfont"
              ],
              "sameAs": "https://go.drugbank.com/drugs/DB18518"
            }
          ],
          "publisher": {
            "@id": "https://www.neurocrine.com/#org"
          },
          "breadcrumb": {
            "@id": "https://www.crenessityhcp.com/videos#breadcrumbs"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.crenessityhcp.com/videos#breadcrumbs",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.crenessityhcp.com"
            },
            {
              "@type": "ListItem",
              "position": 2,
              "name": "Videos",
              "item": "https://www.crenessityhcp.com/videos"
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://www.neurocrine.com/#org",
          "name": "Neurocrine Biosciences, Inc.",
          "url": "https://www.neurocrine.com/",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.crenessityhcp.com/images/logos/hcp/Neurocrine-Biosciences-Logo.svg"
          }
        }
      ]
    }
  ]
};